export const NO_DATA_VALUE = -999;
export const MENUS_INDEX = {
  SCALES: {
    GLOBAL: 0,
    NATIONAL: 1,
    REGIONAL: 2,
    LOCAL: 3
  },
  SECTORS: {
    GLOBAL_AQUACULTURE: 0,
    GLOBAL_ENERGY: 1,
    NATIONAL_AQUACULTURE: 0,
    NATIONAL_ENERGY: 1,
    REGIONAL_AQUACULTURE: 0,
    REGIONAL_ENERGY: 1
  }
};

export const BTM_PANELS = {
  DATAHUB: {
    SEARCH: "datahub-search",
    VIEWER: "datahub-viewer"
  },
  BLUEGROWTH: {
    SEARCH: "bluegrowth-search",
    VIEWER: "bluegrowth-viewer"
  },
  TOOLS: {
    SEARCH: "tools-search",
    VIEWER: "tools-viewer",
    RESULTS: "tools-results"
  }
};

export const BTM_TOOLS = {
  BIOLOGICAL_SUITABILITY: "bio",
  WAVE_ENERGY_SUITABILITY: "waveEnergy",
  WIND_ENERGY_SUITABILITY: "windEnergy"
};

///todo: (Enum) harcoded moments data, should get from database
export const MOMENTS = {
  past: {
    id: 1,
    name: "Past"
  },
  present: {
    id: 2,
    name: "Present"
  },
  shortTerm: {
    id: 3,
    name: "Short-term Forecast"
  },
  climateChange: {
    id: 4,
    name: "Climate Change"
  }
};

export const TIMELINE_MOMENTS = [
  {
    id: 1,
    name: "Past",
    icon: "history",
    color: "#dce8f4"
  },
  {
    id: 2,
    name: "Present",
    icon: "play_arrow",
    color: "#98c5d1"
  },
  {
    id: 3,
    name: "Short-term Forecast",
    icon: "redo",
    color: "#00a09e"
  },
  {
    id: 4,
    name: "Climate Change",
    icon: "last_page",
    color: "#19535F"
  }
];

export const SECTORS = {
  aquaculture: {
    id: 1,
    name: "Aquaculture"
  },
  energy: {
    id: 2,
    name: "Marine Energy"
  }
};

//todo: hack!! hay que resolver en BD las consultas a partir de sector
export const SECTORS_FUTURE = {
  aquaculture: {
    id: 1,
    name: "Aquaculture",
    path:
      "/Global/Aquaculture/BiologicalSuitability/ClimateChange/BiologicalSuitability_CC.nc",
    variables: [
      {
        alias: "Greater Amberjack",
        shortName: "amberjack"
      },
      {
        alias: "Gilthead seabream",
        shortName: "gilthead"
      },
      {
        alias: "Atlantic Bluefin Tuna",
        shortName: "bluefin_tuna"
      },
      {
        alias: "Meagre",
        shortName: "meagre"
      },
      {
        alias: "European Seabass",
        shortName: "seabass"
      },
      {
        alias: "Atlantic Salmon",
        shortName: "atlan_salmon"
      }
    ]
  },
  energy: {
    id: 2,
    name: "Marine Energy",
    path:
      "/Global/Energy/EnergyResourceSuitability/ClimateChange/EnergyResourceSuitability_CC.nc",
    variables: [
      {
        alias: "Wave Resource",
        shortName: "Wave_Resource"
      },
      {
        alias: "Wind Resource",
        shortName: "Wind_resource"
      }
    ]
  }
};

/* harcoded until the new API Boyas is released. The old one don´t have a method to get types */
export const BUOYS_TYPES = [
  {
    id: 1,
    name: "Tide Gauge"
  },
  {
    id: 2,
    name: "Coast Buoy"
  },
  {
    id: 3,
    name: "Station Buoy"
  },
  {
    id: 99,
    name: "Coast Radar"
  }
];
